import {
  Grid,
  MenuItem,
  TextField,
  Paper,
  Button,
  ThemeProvider,
  createMuiTheme,
  FormControl,
  Checkbox,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Iconify from "../../../../components/Iconify";
import { useQuery } from "@apollo/client";
import { LISTAR_TAZAS } from "../../../../graphql/movimientos";
const FrmDetailCobro = (props) => {
  const [inputTasa, setInputTasa] = useState("");
  const formik = useFormik({
    initialValues: {
      tipoIngreso: "",
      folioIngreso: "",
      totalFolios: 0,
      totalPermisos: 0,
      monto: "",
      comision: 0,
      neto: "",
      aplicaComision: false,
      tasa: 0,
    },
    onSubmit: async (datos) => {
      delete datos.tasa;
      datos.totalFolios = parseInt(datos.totalFolios);
      datos.totalPermisos = parseInt(datos.totalPermisos);
      console.log(datos);
      props.func(datos);
      formik.resetForm();
    },
  });

  const { data: tasaData, loading: tasaloading } = useQuery(LISTAR_TAZAS);

  useEffect(() => {
    if (formik.values.tipoIngreso === "1") {
      formik.setFieldValue("totalPermisos", 0);
      formik.setFieldValue("totalFolios", 0);
      formik.setFieldValue("folioIngreso", "");
    } else if (formik.values.tipoIngreso === "3") {
      formik.setFieldValue("totalPermisos", 0);
      formik.setFieldValue("totalFolios", 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.tipoIngreso]);

  useEffect(() => {
    if (formik.values.aplicaComision) {
    }
  }, [formik.values.aplicaComision]);

  const theme = createMuiTheme({
    palette: {
      text: {
        disabled: "green",
      },
    },
  });
  const comisionColor = createMuiTheme({
    palette: {
      text: {
        disabled: "red",
      },
    },
  });
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();

      //Primero valido si tiene selección aplicaComision
      if (formik.values.aplicaComision) {
        formik.setFieldValue("neto", e.target.value - formik.values.comision);
      } else {
        if (formik.values.tipoIngreso === "2") {
          let t = inputTasa;
          formik.setFieldValue("comision", formik.values.totalPermisos * t);
        //formik.setFieldValue("comision",  t);
          formik.setFieldValue(
            "neto",
            e.target.value - formik.values.totalPermisos * t
          );
        } else if (formik.values.tipoIngreso === "3") {
          formik.setFieldValue("comision", formik.values.totalPermisos * 0);
          formik.setFieldValue(
            "neto",
            e.target.value - formik.values.totalPermisos * 0
          );
        } else {
          let t = inputTasa / 100;
          formik.setFieldValue("comision", e.target.value * t);
          formik.setFieldValue("neto", e.target.value - e.target.value * t);
        }
      }
    }
  };

  const handleKeyPress2 = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      //Primero valido si tiene selección aplicaComision
      if (formik.values.aplicaComision) {
        formik.setFieldValue("neto", e.target.value - formik.values.comision);
      } else {
        if (formik.values.tipoIngreso === "2") {
          formik.setFieldValue("comision", formik.values.totalPermisos * 10);
          formik.setFieldValue(
            "neto",
            e.target.value - formik.values.totalPermisos * 10
          );
        } else {
          formik.setFieldValue("comision", e.target.value * 0.1);
          formik.setFieldValue("neto", e.target.value - e.target.value * 0.1);
        }
      }
    }
  };

  if (tasaloading) return <h1>Generando elementos</h1>;

  const { listarTazas } = tasaData;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        formik.handleSubmit(e);
      }}
      noValidate
    >
      <Grid container alignItems="flex-start" spacing={3}>
        <Grid item xs={12} md={12} lg={3}>
          <TextField
            select
            fullWidth
            id="tipoIngreso"
            name="tipoIngreso"
            label="Tipo de Ingreso"
            variant="standard"
            onChange={formik.handleChange}
            value={formik.values.tipoIngreso}
          >
            <MenuItem value="1">Basura</MenuItem>
            <MenuItem value="2">Permisos</MenuItem>
            <MenuItem value="3">Ingresos Oficina</MenuItem>
          </TextField>
        </Grid>

        <Grid item xs={12} md={12} lg={3}>
          <Autocomplete
            fullWidth
            freeSolo
            id="tasa"
            name="tasa"
            options={listarTazas}
            getOptionLabel={(option) => option.tasa}
            onChange={(e, value) => {
              formik.setFieldValue("tasa", value.id);
            }}
            inputValue={inputTasa}
            onInputChange={(_, v) => setInputTasa(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Tasa"
                variant="standard"
                name="tax"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12} md={12} lg={2}>
          <Button
            type="submit"
            onClick={formik.handleSubmit}
            startIcon={<Iconify icon="eva:save-outline" />}
          >
            Agregar
          </Button>
        </Grid>

        <Grid item xs={12} md={12} lg={3}>
          <FormControlLabel
            control={
              <Checkbox
                id="aplicaComision"
                name="aplicaComision"
                value={formik.values.aplicaComision}
                onChange={formik.handleChange}
              />
            }
            label="No Alicar comisión"
          ></FormControlLabel>
        </Grid>
        {formik.values.tipoIngreso === "2" && (
          <>
            <Grid item xs={12} md={12} lg={4}>
              <TextField
                label="Folio"
                variant="standard"
                id="folioIngreso"
                value={formik.values.folioIngreso}
                onChange={formik.handleChange}
              />
            </Grid>
          </>
        )}
        {formik.values.tipoIngreso === "3" && (
          <>
            <Grid item xs={12} md={12} lg={4}>
              <TextField
                label="Folio"
                variant="standard"
                id="folioIngreso"
                value={formik.values.folioIngreso}
                onChange={formik.handleChange}
              />
            </Grid>
          </>
        )}

        {formik.values.tipoIngreso === "2" && (
          <>
            <Grid item xs={12} md={12} lg={4}>
              <TextField
                label="Total de Folios"
                variant="standard"
                id="totalFolios"
                value={formik.values.totalFolios}
                onChange={formik.handleChange}
              />
            </Grid>
            <Grid item xs={12} md={12} lg={4}>
              <TextField
                label="T. Permisos"
                variant="standard"
                id="totalPermisos"
                value={formik.values.totalPermisos}
                onChange={formik.handleChange}
              />
            </Grid>
          </>
        )}
        <Grid item xs={12} md={12} lg={4}>
          {" "}
          <ThemeProvider theme={comisionColor}>
            <TextField
              label="Comisión"
              variant="standard"
              name="comision"
              value={formik.values.comision}
              disabled={!formik.values.aplicaComision}
              onChange={formik.handleChange}
              type={"number"}
            />
          </ThemeProvider>
          {formik.errors.comision}
        </Grid>
        <Grid item xs={12} md={12} lg={4}>
          <TextField
            label="Cobro"
            variant="standard"
            id="monto"
            type={"number"}
            value={formik.values.monto}
            //value={monto}
            onChange={formik.handleChange}
            //  onChange={changeMonto}
            onKeyPress={(e) => {
              handleKeyPress(e);
            }}
          />
          {formik.errors.monto}
        </Grid>

        <Grid item xs={12} md={12} lg={4}>
          <ThemeProvider theme={theme}>
            <TextField
              label="Neto"
              variant="standard"
              id="neto"
              name="neto"
              value={formik.values.neto}
              disabled
              onChange={formik.handleChange}
              type={"number"}
              spacing={4}
            />
          </ThemeProvider>
          {formik.errors.neto}
        </Grid>
      </Grid>
    </form>
  );
};

export default FrmDetailCobro;
